export default [
  {
    title: 'Dashboard',
    group: 'apps',
    icon: 'dashboard',
    name: 'Dashboard',
    roleId: 1,
  },
  {
    title: 'Báo cáo',
    group: 'bao-cao',
    icon: 'speed',
    name: 'Report',
    roleId: 4,
    items: [
      {
        title: 'Lợi nhuận đặt hàng',
        name: 'thong-ke-loi-nhuan-dat-hang',
        component: 'thong-ke-loi-nhuan-dat-hang',
        roleId: 1,
      },
      { 
        title: 'Phí mua hàng',
        name: 'thong-ke-phi-mua-hang',
        component: 'thong-ke-phi-mua-hang',
        roleId: 2,
      },
      {
        title: 'Phí vận chuyển',
        name: 'thong-ke-phi-van-chuyen',
        component: 'thong-ke-phi-van-chuyen',
        roleId: 4
      },
      {
        title: 'Chênh tỷ giá',
        name: 'thong-ke-tien-te',
        component: 'thong-ke-tien-te',
        roleId: 8,
      },
      // {
      //   title: 'Tài chính',
      //   name: 'bao-cao-tai-chinh',
      //   component: 'bao-cao-tai-chinh',
      //   roleId: 16,
      // },
      {
        title: 'Tiền khách nạp',
        name: 'bao-cao-nap-tien',
        component: 'bao-cao-nap-tien',
        roleId: 8
      },
      {
        title: 'Doanh thu tổng',
        name: 'bao-cao-tong-hop',
        component: 'bao-cao-tong-hop',
        roleId: 8
      },
    ]
  },
  {
    title: 'Đơn hàng',
    group: 'apps',
    icon: 'shopping_cart',
    name: 'OrderList',
    roleId: 32,
    children: [
      { name: 'orderdetail', title: 'Chi tiết đơn hàng', component: 'OrderDetail' }
    ]
  },
  {
    title: 'Thanh toán',
    group: 'apps',
    icon: 'attach_money',
    name: 'PayOrderList',
    roleId: 128
  },
  {
    title: 'Khách hàng',
    group: 'apps',
    icon: 'account_box',
    name: 'CustomerList',
    roleId: 8,
    children: [
      { name: 'CustomerDetail', title: 'Chi tiết khách hàng', component: 'CustomerDetail'  }
    ]
  },
  {
    title: 'Lịch sử rút tiền',
    group: 'apps',
    icon: 'receipt_long',
    name: 'WithdrawHistory',
    roleId: 8   
  },
  {
    title: 'Ký gửi',
    group: 'apps',
    icon: 'store',
    name: 'Deposit',
    roleId: 64,
    children: [
      { name: 'DepositDetail', title: 'Chi tiết đơn hàng', component: 'DepositDetail' }
    ]
  },
  // {
  //   title: 'Khiếu nại',
  //   group: 'apps',
  //   icon: 'new_releases',
  //   name: 'Complain',
  //   children: [
  //     { name: 'ComplainDetail', title: 'Chi tiết khiếu nại', component: 'ComplainDetail' }
  //   ]
  // },
  // {
  //   title: 'Thống kê',
  //   group: 'apps',
  //   icon: 'insert_chart',
  //   name: 'Report',
  // },
  {
    title: 'Nạp tiền',
    group: 'apps',
    icon: 'monetization_on',
    name: 'RechargeNew',
    roleId: 16
  },
  {
    title: 'Mã vận đơn',
    group: 'apps',
    icon: 'flight',
    name: 'Transaction',
    roleId: 512
  },
  {
    title: 'Nhập kho TQ',
    group: 'apps',
    icon: 'assignment',
    name: 'StoreManager',
    roleId: 1024
  },
  {
    title: 'Quản lý bao hàng',
    group: 'apps',
    icon: 'archive',
    name: 'BigPackage',
    roleId: 2048
  }, 
  {
    title: 'Nhập kho VN',
    group: 'apps',
    icon: 'assignment',
    name: 'StoreManagerVN',
    roleId: 256
  },
  {
    title: 'Cài đặt',
    group: 'cai-dat',
    icon: 'settings',
    name: 'Setting',
    roleId: 2,
    items: [
      {
        title: 'Kho hàng',
        name: 'WarehouseList',
        component: 'WarehouseList', 
        children: [
          { name: 'WarehouseDetail', title: 'Chi tiết kho', component: 'WarehouseDetail' }
        ]
      },
      {
        title: 'Phương thức v.chuyển',
        name: 'ShippingMethodList',
        component: 'ShippingMethodList', 
        children: [
          { name: 'ShippingMethodDetail', title: 'Chi tiết phương thức vận chuyển', component: 'ShippingMethodDetail' }
        ]
      },
      {
        title: 'Nhân viên',
        name: 'StaffList',
        component: 'StaffList', 
        children: [
          { name: 'StaffDetail', title: 'Chi tiết nhân viên', component: 'StaffDetail' }
        ]
      },
      { 
        name: 'CustomerLevel', 
        title: 'Quản lý Level', 
        component: 'CustomerLevel',
        children: [
          { name: 'CustomerLevelDetail', title: 'Chi tiết level', component: 'CustomerLevelDetail' }
        ]
      },
      {
        name: 'FeeBuyList', 
        title: 'Phí mua hàng', 
        component: 'FeeBuyList', 
        children: [
          { name: 'FeeBuyDetail', title: 'Chi tiết phí mua hàng', component: 'FeeBuyDetail' }
        ]
      },
      {
        name: 'FeeWeightList', 
        title: 'Phí cân nặng', 
        component: 'FeeWeightList', 
        children: [
          { name: 'FeeWeightDetail', title: 'Chi tiết phí cân nặng', component: 'FeeWeightDetail' }
        ]
      },
      {
        name: 'Configuration', 
        title: 'Cấu hình chung', 
        component: 'Configuration'
      }
    ]
  },
  // {
  //   title: 'Nhập liệu',
  //   group: 'apps',
  //   icon: 'input',
  //   name: 'DataManager',
  // },  
];
